import React from 'react';
import { Helmet } from 'react-helmet';
import SubHeader from 'components/SubHeader';
import FooterBar from 'components/FooterBar';
import ParkingTable from './components/ParkingTable';
import {
  Content,
  Container,
} from 'components/BookingMain/styles';

const Parking = () => {

  return (
    <>
      <Helmet>
        <title>Parking - Rook Hotel PMS</title>
        <meta name="description" content="Parking - Rook Hotel PMS" />
      </Helmet>
      <SubHeader>
        <div className='title'>
          Parking
        </div>
      </SubHeader>
      <Content additionalstyle={`
        margin-top: 100px;
      `}>
        <Container>
          <ParkingTable />
        </Container>
      </Content>
      <FooterBar />
    </>
  );
};

export default Parking;